import {
  put, all, call, select, takeEvery,
} from 'redux-saga/effects';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import axios from 'axios';
import { startSubmit, stopSubmit, reset } from 'circe/forms/actions';
import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import { FORM_NAME } from 'domain/shipment/factoryUpload/fuse/Forms/FactoryUpload/constants';
import { operatorClient } from 'domain/HttpClients';
import * as api from './api';
import { batchSalesOrders, batchedSuccessfully, batchedSalesOrders } from './actions';

function readFileAsBlob(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const blob = new Blob([reader.result], { type: file.type });
      resolve(blob);
    };

    reader.onerror = reject;

    reader.readAsArrayBuffer(file);
  });
}

function* doBatchSalesOrders(context, action) {
  yield put(startSubmit(FORM_NAME));

  const { payload } = action;
  const { values } = payload;
  const { factoryFiles, email } = values;

  try {
    const urls = [];

    const response = yield operatorClient
      .Get('/api/upload')
      .withParams({
        contentType: factoryFiles[0].type,
        numberOfFilesToUpload: factoryFiles.length,
        keyName: factoryFiles[0].name,
      })
      .send();

    if (response.length > 0) {
      yield all(
        response.map(async (item, index) => {
          const file = factoryFiles[index];
          const config = {
            headers: {
              'Content-Type': file.type,
            },
          };
          const blob = await readFileAsBlob(file);
          const data = await axios.put(item, blob, config);
          const downloadUrlResponse = await operatorClient
            .Get('api/upload/download-url')
            .withParams({
              contentType: factoryFiles[0].type,
              numberOfFilesToUpload: factoryFiles.length,
              keyName: factoryFiles[0].name,
            })
            .send();
          urls.push(downloadUrlResponse[0]);
        }),
      );

      if (urls.length) {
        yield all(
          urls.map(async (item) => {
            const response = await operatorClient
              .Patch('/api/masheed/upload-factory-report')
              .withData({
                email: [email],
                fileUrl: item,
              })
              .send();
          }),
        );
      } else {
        throw new Error('No response received from the server.');
      }

      yield put(batchedSuccessfully());
      yield put(
        showNotification(
          I18n.str('filesUploadedSuccessfully', 'Files uploaded successfully.'),
          'success',
        ),
      );
      yield put(reset(FORM_NAME));
    } else {
      throw new Error('No response received from the server.');
    }
  } catch (error) {
    console.error(error);
    yield put(stopSubmit(FORM_NAME));
    yield put(batchedSuccessfully());
    yield put(
      showNotification(I18n.str('error', 'Something went wrong. Please try again.'), 'error'),
    );
  }
}

function* watcher(context) {
  yield all([takeEvery(batchSalesOrders().type, doBatchSalesOrders, context)]);
}

export default watcher;
